const React = require("react")
const { BookingProvider } = require("./src/context/bookingStore")
require('./src/scss/style.scss')


exports.wrapRootElement = ({ element }) => {
    return (
        <BookingProvider>
                {element}
        </BookingProvider>
    )
}